import React, { useMemo, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginScreen from './screens/LoginScreen';
import PortalScreen from './screens/PortalScreen';
import './App.css';

const AUTH_KEY = 'vt_dashboard_authed_v1';

function App() {
  const [isAuthed, setIsAuthed] = useState(() => {
    return localStorage.getItem('vt_dashboard_token') !== null;
  });

  const onLogin = (authData) => {
    if (authData?.jwt) localStorage.setItem('vt_dashboard_token', authData.jwt);
    localStorage.setItem(AUTH_KEY, 'true');
    setIsAuthed(true);
  };

  const onLogout = () => {
    localStorage.removeItem(AUTH_KEY);
    localStorage.removeItem('vt_dashboard_token');
    setIsAuthed(false);
  };

  const appShellClassName = useMemo(() => ['vt-app', 'vt-theme--persona'].join(' '), []);

  return (
    <div className={appShellClassName}>
      <Routes>
        {isAuthed ? (
          <>
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route path="/*" element={<PortalScreen onLogout={onLogout} />} />
          </>
        ) : (
          <>
            <Route
              path="/login"
              element={<LoginScreen onLogin={onLogin} />}
            />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}
      </Routes>
    </div>
  );
}

export default App;
